"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListLevelFontNoProofHistoryItem = exports.ListLevelFontUnderlineWordsOnlyHistoryItem = exports.ListLevelFontUnderlineColorHistoryItem = exports.ListLevelFontStrikeoutColorHistoryItem = exports.ListLevelFontStrikeoutWordsOnlyHistoryItem = exports.ListLevelFontStrikeoutTypeHistoryItem = exports.ListLevelFontSizeHistoryItem = exports.ListLevelFontScriptHistoryItem = exports.ListLevelFontNameHistoryItem = exports.ListLevelFontItalicHistoryItem = exports.ListLevelFontHiddenHistoryItem = exports.ListLevelFontShadingInfoHistoryItem = exports.ListLevelFontTextColorHistoryItem = exports.ListLevelFontUnderlineTypeHistoryItem = exports.ListLevelFontSmallCapsHistoryItem = exports.ListLevelFontCapsHistoryItem = exports.ListLevelFontBoldHistoryItem = exports.ListLevelCharacterPropertiesHistoryItemBase = void 0;
var tslib_1 = require("tslib");
var errors_1 = require("@devexpress/utils/lib/errors");
var history_item_1 = require("../base/history-item");
var ListLevelCharacterPropertiesHistoryItemBase = (function (_super) {
    tslib_1.__extends(ListLevelCharacterPropertiesHistoryItemBase, _super);
    function ListLevelCharacterPropertiesHistoryItemBase(modelManipulator, isAbstractList, listIndex, levelIndex, newValue, newUse) {
        var _this = _super.call(this, modelManipulator) || this;
        _this.newValue = newValue;
        _this.isAbstractList = isAbstractList;
        _this.listIndex = listIndex;
        _this.levelIndex = levelIndex;
        _this.newUse = newUse;
        return _this;
    }
    ListLevelCharacterPropertiesHistoryItemBase.prototype.redo = function () {
        this.oldState = this.getManipulator().setValue(this.modelManipulator.model, this.isAbstractList, this.listIndex, this.levelIndex, this.newValue, this.newUse);
    };
    ListLevelCharacterPropertiesHistoryItemBase.prototype.undo = function () {
        this.getManipulator().restoreValue(this.modelManipulator.model, this.oldState);
    };
    ListLevelCharacterPropertiesHistoryItemBase.prototype.getManipulator = function () {
        throw new Error(errors_1.Errors.NotImplemented);
    };
    return ListLevelCharacterPropertiesHistoryItemBase;
}(history_item_1.HistoryItem));
exports.ListLevelCharacterPropertiesHistoryItemBase = ListLevelCharacterPropertiesHistoryItemBase;
var ListLevelFontBoldHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelFontBoldHistoryItem, _super);
    function ListLevelFontBoldHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelFontBoldHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelCharacterProperties.fontBold;
    };
    return ListLevelFontBoldHistoryItem;
}(ListLevelCharacterPropertiesHistoryItemBase));
exports.ListLevelFontBoldHistoryItem = ListLevelFontBoldHistoryItem;
var ListLevelFontCapsHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelFontCapsHistoryItem, _super);
    function ListLevelFontCapsHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelFontCapsHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelCharacterProperties.fontCaps;
    };
    return ListLevelFontCapsHistoryItem;
}(ListLevelCharacterPropertiesHistoryItemBase));
exports.ListLevelFontCapsHistoryItem = ListLevelFontCapsHistoryItem;
var ListLevelFontSmallCapsHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelFontSmallCapsHistoryItem, _super);
    function ListLevelFontSmallCapsHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelFontSmallCapsHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelCharacterProperties.fontSmallCaps;
    };
    return ListLevelFontSmallCapsHistoryItem;
}(ListLevelCharacterPropertiesHistoryItemBase));
exports.ListLevelFontSmallCapsHistoryItem = ListLevelFontSmallCapsHistoryItem;
var ListLevelFontUnderlineTypeHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelFontUnderlineTypeHistoryItem, _super);
    function ListLevelFontUnderlineTypeHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelFontUnderlineTypeHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelCharacterProperties.fontUnderlineType;
    };
    return ListLevelFontUnderlineTypeHistoryItem;
}(ListLevelCharacterPropertiesHistoryItemBase));
exports.ListLevelFontUnderlineTypeHistoryItem = ListLevelFontUnderlineTypeHistoryItem;
var ListLevelFontTextColorHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelFontTextColorHistoryItem, _super);
    function ListLevelFontTextColorHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelFontTextColorHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelCharacterProperties.textColor;
    };
    return ListLevelFontTextColorHistoryItem;
}(ListLevelCharacterPropertiesHistoryItemBase));
exports.ListLevelFontTextColorHistoryItem = ListLevelFontTextColorHistoryItem;
var ListLevelFontShadingInfoHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelFontShadingInfoHistoryItem, _super);
    function ListLevelFontShadingInfoHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelFontShadingInfoHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelCharacterProperties.shadingInfo;
    };
    return ListLevelFontShadingInfoHistoryItem;
}(ListLevelCharacterPropertiesHistoryItemBase));
exports.ListLevelFontShadingInfoHistoryItem = ListLevelFontShadingInfoHistoryItem;
var ListLevelFontHiddenHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelFontHiddenHistoryItem, _super);
    function ListLevelFontHiddenHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelFontHiddenHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelCharacterProperties.fontHidden;
    };
    return ListLevelFontHiddenHistoryItem;
}(ListLevelCharacterPropertiesHistoryItemBase));
exports.ListLevelFontHiddenHistoryItem = ListLevelFontHiddenHistoryItem;
var ListLevelFontItalicHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelFontItalicHistoryItem, _super);
    function ListLevelFontItalicHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelFontItalicHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelCharacterProperties.fontItalic;
    };
    return ListLevelFontItalicHistoryItem;
}(ListLevelCharacterPropertiesHistoryItemBase));
exports.ListLevelFontItalicHistoryItem = ListLevelFontItalicHistoryItem;
var ListLevelFontNameHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelFontNameHistoryItem, _super);
    function ListLevelFontNameHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelFontNameHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelCharacterProperties.fontName;
    };
    return ListLevelFontNameHistoryItem;
}(ListLevelCharacterPropertiesHistoryItemBase));
exports.ListLevelFontNameHistoryItem = ListLevelFontNameHistoryItem;
var ListLevelFontScriptHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelFontScriptHistoryItem, _super);
    function ListLevelFontScriptHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelFontScriptHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelCharacterProperties.script;
    };
    return ListLevelFontScriptHistoryItem;
}(ListLevelCharacterPropertiesHistoryItemBase));
exports.ListLevelFontScriptHistoryItem = ListLevelFontScriptHistoryItem;
var ListLevelFontSizeHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelFontSizeHistoryItem, _super);
    function ListLevelFontSizeHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelFontSizeHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelCharacterProperties.fontSize;
    };
    return ListLevelFontSizeHistoryItem;
}(ListLevelCharacterPropertiesHistoryItemBase));
exports.ListLevelFontSizeHistoryItem = ListLevelFontSizeHistoryItem;
var ListLevelFontStrikeoutTypeHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelFontStrikeoutTypeHistoryItem, _super);
    function ListLevelFontStrikeoutTypeHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelFontStrikeoutTypeHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelCharacterProperties.fontStrikeoutType;
    };
    return ListLevelFontStrikeoutTypeHistoryItem;
}(ListLevelCharacterPropertiesHistoryItemBase));
exports.ListLevelFontStrikeoutTypeHistoryItem = ListLevelFontStrikeoutTypeHistoryItem;
var ListLevelFontStrikeoutWordsOnlyHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelFontStrikeoutWordsOnlyHistoryItem, _super);
    function ListLevelFontStrikeoutWordsOnlyHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelFontStrikeoutWordsOnlyHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelCharacterProperties.fontStrikeoutWordsOnly;
    };
    return ListLevelFontStrikeoutWordsOnlyHistoryItem;
}(ListLevelCharacterPropertiesHistoryItemBase));
exports.ListLevelFontStrikeoutWordsOnlyHistoryItem = ListLevelFontStrikeoutWordsOnlyHistoryItem;
var ListLevelFontStrikeoutColorHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelFontStrikeoutColorHistoryItem, _super);
    function ListLevelFontStrikeoutColorHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelFontStrikeoutColorHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelCharacterProperties.fontStrikeoutColor;
    };
    return ListLevelFontStrikeoutColorHistoryItem;
}(ListLevelCharacterPropertiesHistoryItemBase));
exports.ListLevelFontStrikeoutColorHistoryItem = ListLevelFontStrikeoutColorHistoryItem;
var ListLevelFontUnderlineColorHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelFontUnderlineColorHistoryItem, _super);
    function ListLevelFontUnderlineColorHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelFontUnderlineColorHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelCharacterProperties.fontUnderlineColor;
    };
    return ListLevelFontUnderlineColorHistoryItem;
}(ListLevelCharacterPropertiesHistoryItemBase));
exports.ListLevelFontUnderlineColorHistoryItem = ListLevelFontUnderlineColorHistoryItem;
var ListLevelFontUnderlineWordsOnlyHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelFontUnderlineWordsOnlyHistoryItem, _super);
    function ListLevelFontUnderlineWordsOnlyHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelFontUnderlineWordsOnlyHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelCharacterProperties.fontUnderlineWordsOnly;
    };
    return ListLevelFontUnderlineWordsOnlyHistoryItem;
}(ListLevelCharacterPropertiesHistoryItemBase));
exports.ListLevelFontUnderlineWordsOnlyHistoryItem = ListLevelFontUnderlineWordsOnlyHistoryItem;
var ListLevelFontNoProofHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelFontNoProofHistoryItem, _super);
    function ListLevelFontNoProofHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelFontNoProofHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelCharacterProperties.fontNoProof;
    };
    return ListLevelFontNoProofHistoryItem;
}(ListLevelCharacterPropertiesHistoryItemBase));
exports.ListLevelFontNoProofHistoryItem = ListLevelFontNoProofHistoryItem;
